import {
    ANIMATION_COMPLETE_RATIO_VERTICAL,
    MAX_BACKGROUND_BRIGHTNESS,
    MAX_BACKGROUND_PAN_RATIO_HORIZONTAL,
    MAX_BACKGROUND_SCALE,
    MIN_BACKGROUND_BRIGHTNESS,
    MIN_BACKGROUND_SCALE,
} from './modal-gesture.constants';

export class ModalGesturePanUtility {
    static getBackgroundPanHorizontalMax(viewportWidth: number): number {
        return viewportWidth * MAX_BACKGROUND_PAN_RATIO_HORIZONTAL;
    }

    static getBackgroundBrightnessHorizontal(currentPosition: number, viewportWidth: number): number {
        return this.getBackgroundBrightness(currentPosition, viewportWidth);
    }

    static getBackgroundBrightnessVertical(currentPosition: number, viewportHeight: number): number {
        return this.getBackgroundBrightness(currentPosition, viewportHeight);
    }

    static getBackgroundPanHorizontal(currentPosition: number, viewportWidth: number): number {
        const maxBackgroundPan = this.getBackgroundPanHorizontalMax(viewportWidth);

        const backgroundPanPerPixel = maxBackgroundPan * (currentPosition / viewportWidth);
        const backgroundPanInverted = maxBackgroundPan - Math.round(backgroundPanPerPixel);

        return backgroundPanInverted;
    }

    static getBackgroundZoomVertical(currentPosition: number, viewportHeight: number): number {
        const panRatio = this.getFractionPanComplete(currentPosition, viewportHeight);

        const scalePerPixel = panRatio * (MAX_BACKGROUND_SCALE - MIN_BACKGROUND_SCALE);
        const currentScale = MIN_BACKGROUND_SCALE + scalePerPixel;

        return this.clamp(MIN_BACKGROUND_SCALE, currentScale, MAX_BACKGROUND_SCALE);
    }

    private static getBackgroundBrightness(currentPosition: number, screenDimension: number): number {
        const panRatio = this.getFractionPanComplete(currentPosition, screenDimension);

        const brightnessPerPixel = panRatio * (MAX_BACKGROUND_BRIGHTNESS - MIN_BACKGROUND_BRIGHTNESS);
        const currentBrightness = MIN_BACKGROUND_BRIGHTNESS + brightnessPerPixel;

        return this.clamp(MIN_BACKGROUND_BRIGHTNESS, currentBrightness, MAX_BACKGROUND_BRIGHTNESS);
    }

    static getFractionPanComplete(currentPosition: number, viewportHeight: number): number {
        const animationCompleteAt = viewportHeight * ANIMATION_COMPLETE_RATIO_VERTICAL;

        const clampedPosition = Math.min(currentPosition, animationCompleteAt);

        return clampedPosition / animationCompleteAt;
    }

    static clamp(min: number, value: number, max: number): number {
        return Math.max(min, Math.min(max, value));
    }
}
